import Vue from 'vue';
import Vue2Filters from 'vue2-filters';
import { namespace } from 'vuex-class';

import { Component, Watch, Prop, Inject, Emit } from 'vue-property-decorator';

import ProjectOverview from '@/components/project-overview.vue';
import ProjectOverviewHeader from '@/components/project-overview-header.vue';
import { crmapi } from '@/types/crm-types';
import { project } from '@/store/project-module';

const startpage = namespace('startpage');

@Component({ components: { ProjectOverview, ProjectOverviewHeader }, mixins: [Vue2Filters.mixin] })
export default class Startpage extends Vue {
  @startpage.Getter('projects')
  private projects: crmapi.Project[];

  @startpage.Getter('searchstring')
  private searchstring: string;

  @startpage.Action('loadProjects')
  private async LoadProjects(activeOnly: boolean) {
  }

  private async beforeMount() {
    await this.loadData();
  }

  private async loadData() {
    try {
      this.LoadProjects(localStorage.showInactiveProjects === 'true');
    } catch {}
  }
}
